import { render, staticRenderFns } from "./HorizontalHeader.vue?vue&type=template&id=af04d844"
import script from "./HorizontalHeader.vue?vue&type=script&lang=js"
export * from "./HorizontalHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports